import { createAction, props } from '@ngrx/store';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { RiderEvent } from '@app/rest-client/faxe/models/rider-event';

const prefix = '[FAXE-RIDER-EVENT]';

export const fetchAllRiderEvents = createAction(
  `${prefix} - fetch all`,
  props<{ raceGuid: string, requiredSliceState: SliceState, issuerStack: string[] }>()
);

export const getRiderEvents = createAction(
  `${prefix} - get`,
  props<{ raceGuid: string, requiredSliceState: SliceState, issuerStack: string[] }>()
);

export const addManyRiderEvents = createAction(
  `${prefix} - add many`,
  props<{ models: RiderEvent[]; sliceState: SliceState; issuerStack: string[] }>()
);

export const patchManyRiderEvents = createAction(
  `${prefix} - patch many`,
  props<{ models: RiderEvent[]; issuerStack: string[] }>()
);

export const purgeRiderEvents = createAction(
  `${prefix} - purge`,
  props<{ issuerStack: string[]; correlationId: string }>()
);
